import type { StaticEntityType, StaticLayerPayload } from "@config";
import { Element, Set } from "@library-containers/layers";
import type { ComponentType } from "react";
import "../styles/narrator-library.scss";
import { NarratorView } from "./Narrator.view";

export const NarratorLibrary = ({ entity }: { entity: StaticEntityType }) => (
  <NarratorView
    entity={entity}
    elements={getElements(entity)}
    setChild={Set as ComponentType<StaticLayerPayload | { id: string }>}
    elementChild={Element as ComponentType<StaticLayerPayload | { id: string }>}
  />
);

const getElements = (entity: StaticEntityType) => {
  const elements: Record<string, StaticEntityType[]> = {};
  entity.children.forEach((set: StaticEntityType) => {
    if (set && set.children && set.children[1]) {
      const element = set.children[1].children[0];
      elements[set.id] = [element];
    }
  });
  return elements;
};
